//medidad Banner 650x360px
export const ultimasNoticias = [
    {
        "imagen" :"../assets/imgs/Convocatorias/2026/Narrativa Ixmiquilpan .jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/29.-taller  narrativa audiovisual  comunitaria Ixmiquilpan.pdf",
        "titulo" : "Taller de narrativa audiovisual Ixmiquilpan",
        "fecha" : "Sujeto a disponibilidad",
        "categoria" : "Talleres"
    },
    {
        "imagen" :"../assets/imgs/Convocatorias/2026/Narrativa Tlahuelilpan.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/28.-taller  narrativa audiovisual  comunitaria tlahuelilpan .pdf",
        "titulo" : "Taller de narrativa audiovisual Tlahuelilpan",
        "fecha" : "Sujeto a disponibilidad",
        "categoria" : "Talleres"
    },
    {
        "imagen" :"../assets/imgs/Convocatorias/2026/Narrativa Real del Monte .jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/27.-taller  narrativa audiovisual  comunitaria real del monte .pdf",
        "titulo" : "Taller de narrativa audiovisual Real del Monte",
        "fecha" : "Sujeto a disponibilidad",
        "categoria" : "Talleres"
    },
   {
        "imagen" :"../assets/imgs/Convocatorias/2026/AIEC.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/créditos AIEC 2026.pdf",
        "titulo" : "Agentes Culturales de Cambio: Red de Formación Artística Especializada como Factor de Protección para las Infancias",
        "fecha" : "Sujeto a disponibilidad",
        "categoria" : "créditos"
    },
     {
        "imagen" :"../assets/imgs/Convocatorias/2026/Diplomado Educación Musical.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/26.-Diplomado en  Educación Musical.pdf",
        "titulo" : "Diplomado en Educación Musical (Segunda edición)",
        "fecha" : "Sujeto a disponibilidad de cupo",
        "categoria" : "Convocatoria"
    },
   {
        "imagen" :"../assets/imgs/Convocatorias/2026/Diplomado dramaturgia.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/25.-DIPLOMADO EN DRAMATURGIA;  tejido textual del drama-trama.pdf",
        "titulo" : "Diplomado en dramaturgia; tejido textual del drama-trama",
        "fecha" : "Sujeto a disponibilidad de cupo",
        "categoria" : "Convocatoria"
    },
   {
        "imagen" :"../assets/imgs/Convocatorias/2026/Narrativa audiovisual.jpg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/24.-taller  narrativa audiovisual  comunitaria.pdf",
        "titulo" : "Narrativa audiovisual comunitaria",
        "fecha" : "Sujeto a disponibilidad de cupo",
        "categoria" : "Convocatoria"
    },
     {
        "imagen" :"../assets/imgs/Convocatorias/2026/Diplomado Voz.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/21.- DIPLOMADO PARA PROFESIONALES DE LA VOZ.pdf",
        "titulo" : "Diplomado para profesionales de la voz",
        "fecha" : "Sujeto a disponibilidad de cupo",
        "categoria" : "Convocatoria"
    },
     {
        "imagen" :"../assets/imgs/Convocatorias/2026/Danza clasica.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/22.-convocatoria Valle del Mezquital danza clásica.pdf",
        "titulo" : "Curso Enseñanza de la danza clásica en infancias y adolescencias Técnica cubana, en el CCR del Valle del Mezquital",
        "fecha" : "Sujeto a disponibilidad de cupo",
        "categoria" : "Convocatoria"
    },
     {
        "imagen" :"../assets/imgs/Convocatorias/2026/Danza Clasica1.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/23.-Emiliano Zapata CONVOCATORIA Curso Enseñanza  de la Danza Clasica.pdf",
        "titulo" : "Curso Enseñanza de la danza clásica en infancias y adolescencias Técnica cubana, en el CCR de Emiliano Zapata",
        "fecha" : "Sujeto a disponibilidad de cupo",
        "categoria" : "Convocatoria"
    },
     {
        "imagen" :"../assets/imgs/Convocatorias/2026/Programa de Apoyos.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/13.-Convocatoria Fortalecimiento Actividades Artísticas y Culturales 2026.pdf",
        "titulo" : "Programa de Apoyos para el Fortalecimiento de Actividades Artísticas y Culturales del Ejercicio Fiscal 2026",
        "fecha" : "del 15 de junio al 30 de noviembre del 2026",
        "categoria" : "Convocatoria"
    },
     {
        "imagen" :"../assets/imgs/Convocatorias/2026/Convocatoria Ayudas sociales-2026.png",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/18.-Convocatoria Ayudas sociales-2026.pdf",
        "titulo" : "Programa de Ayudas Sociales para la Realización del Programa para la Administración de Bienes, Servicios y Financiamiento a la Cultura del Ejercicio Fiscal 2026",
        "fecha" : "del 10 de julio al 30 de noviembre del 2026",
        "categoria" : "Convocatoria"
    },
     {
        "imagen" :"../assets/imgs/Convocatorias/2026/Transparencia_en_Corto_2026.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/contraloriat/dir1/Documentos/TRANSP%20EN%20CORTO_CONVOCATORIA_2026.pdf",
        "titulo" : "XXI edición del Concurso Nacional de Transparencia en Corto ",
        "fecha" : "del 05 de junio al 21 de agosto del 2026",
        "categoria" : "Convocatoria"
    },
      
  
   ]